import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";
import store from "@/store";
import "nprogress/nprogress.css";
import _trim from "lodash/trim";
import { loggedIn, removeLoggedIn } from "@/libs/token";
import { cancelAllRequest } from "@/axios/request";

Vue.use(VueRouter);
NProgress.configure({ showSpinner: false });

const routes = [
    {
        path: "/",
        name: "home",
        component: () => import("../views/home.vue")
    },
    {
        path: "/mgmedia",
        redirect: "/" //路由重定向
    },
    {
        path: "/home",
        redirect: "/" //路由重定向
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/login.vue")
    },
    {
        path: "/favorites",
        name: "favorites",
        component: () => import("../views/favorites.vue")
    },
    {
        path: "/favorites-details",
        name: "favorites-details",
        component: () => import("../views/favorites-details.vue")
    },
    {
        path: "/instructions",
        name: "instructions",
        component: () => import("../views/instructions.vue")
    }
];

const loginRoute = to => {
    const query = {};
    if (_trim(to.path, "/")) {
        console.log(to)
        query.redirect = to.fullPath;
    }
    return {
        name: "login",
        query
    };
};

const router = new VueRouter({
    mode: "history",
    base: "/",
    routes
});

//  监听全局导航守卫
router.beforeEach(async (to, from, next) => {
    store.state.global.routerName = to.name;
    //  body 添加路由名称
    document.body.dataset.slug = to.name;

    store.commit("triggerEvtents/updateRouterTriggerFn");
    cancelAllRequest("页面切换，取消请求");
    NProgress.start();

    if (loggedIn("user-logged-in")) {
        // 前端判定为已登录
        if (to.name === "login") {
            // 已登录的情况下，访问登录页，跳转到首页
            next("/");
        } else {
            try {
                //  如果是404 默认跳转到首页
                if (!to.name) {
                    console.log("404 捕获, 重定向到首页");
                    next("/");
                } else {
                    next();
                }
            } catch ({ response: res }) {
                if (res && res.status === 401) {
                    removeLoggedIn();
                    location.href = router.resolve(loginRoute(to)).href;
                } else {
                    NProgress.done();
                    next(false);
                }
            }
        }
    } else if (to.name !== "login") {
        // 没有登录，访问后台，跳到登录页
        next(loginRoute(to));
    } else {
        // 没有登录，访问登录页，通过
        next();
    }

    // 判断是否登录个人中心
    if (loggedIn("user_login_sucs")) {
        // 前端判定为已登录
        if (to.name.includes("favorites")) {
            // 已登录的情况下，访问登录页，跳转到首页
            next();
        }
    } else if (to.name.includes("favorites")) {
        next("/");
    }
});

router.afterEach((to, from, next) => {
    //  储存router ,在非 登录页面显示头部、侧边栏
    store.state.global.routerName = to.name;
});

router.onError(e => {
    NProgress.done();
    throw e;
});

export default router;
